(function() {

	var State = include("springroll.State"),
		Texture = include("PIXI.Texture"),
		Application = include("springroll.Application"),
		Sprite = include("PIXI.Sprite"),
		Elmo = include("heist.Elmo"),
		Guard = include("heist.Guard"),
		GoalTile = include("heist.GoalTile"),
		LevelItem = include("heist.LevelItem"),
		Sound = include("springroll.Sound"),
		Debug = include("springroll.Debug", false);

	var StealthState = function(options)
	{
		State.call(this, new heist.StealthPanel(), options);

		this._levelAssets = [];
		
		this.voPlayer = this.app.voPlayer;
		this.config = this.app.config.game.stealth;

		this.guards = null;
		this.elmo = null;
		this.walls = null;
		this.tiles = null;
		this.decorations = null;
		this.currentTileIndex = 0;
		this.targetTileIndex = 0;
		this.currentDifficulty = 0;
		this.levelData = null;
		this.previousLevels = [];
		this.roundsPlayed = 0;
		this.wrongAnswers = 0;
		this.correctToggle = false;
		this.timeoutToggle = false;
		this.hintsEnabled = false;
		this.timeoutTimer = 0;
		this.timeouts = 0;
		this.timeSinceTimeout = -1;
		this.timeoutTime = this.config.timeoutTimer;
		this.correctAnswers = 0;
		this.elmoClicks = 0;
		this.guardClicks = 0;
		
		this.appIsPlaying = false;
		
		this.update = this.update.bind(this);
		this.enableHints = this.enableHints.bind(this);
		this.nextLevel = this.nextLevel.bind(this);
		this.catchElmo = this.catchElmo.bind(this);
		
		this.on("loading", this.onLoading);
		this.on("loaded", this.onLoaded);
	};

	// Extend State
	var s = State.prototype;
	var p = StealthState.prototype = Object.create(s);
	
	var DIFFICULTY = ["easy", "medium", "hard"];

	p.enter = function()
	{
		s.enter.call(this);
		
		this.roundsPlayed = 0;
		
		this.chooseLevel();
		
		//increase the total # of plays
		this.app.totalPlays++;
		
		//preload some timing important audio
		Sound.instance.preload(["Elmo_TO4_SafeToGo",
				this.app.hasTouch ? "Elmo_TapHere" : "Elmo_ClickHere"]);
	};

	p.onLoaded = function()
	{
		this.panel.setup();

		this.buildLevel();

		this.app.music = "GameLoop";
	};
	
	p.chooseLevel = function()
	{
		var levels = this.config.levels;
		var levelData, i;
		
		if(DEBUG && this.app.options.level)
		{
			for(var diff = 0; diff < levels.length; ++diff)
			{
				var diffLevels = levels[diff];
				for(i = 0; i < diffLevels.length; ++i)
				{
					if(diffLevels[i].id == this.app.options.level)
					{
						this.levelData = diffLevels[i];
						return;
					}
				}
			}
		}
		
		var previousLevels = this.previousLevels, potentialLevels = [];
		//attempt to pick a random level that we have not played yet
		levels = levels[this.currentDifficulty];
		for(i = 0; i < levels.length; ++i)
		{
			if(previousLevels.indexOf(levels[i]) == -1)
				potentialLevels.push(levels[i]);
		}
		//if we have run out of new levels, reset the tracking of old levels
		if(potentialLevels.length == 1)
			previousLevels.length = 0;
		//pick a random level from those available to pick
		levelData = potentialLevels.random();
		//save the level we chose
		this.levelData = levelData;
		//keep track of it to avoid replays
		if(previousLevels.indexOf(levelData) == -1)
			previousLevels.push(levelData);
		
		//log stuff
		if(DEBUG && Debug)
		{
			Debug.debug("================");
			Debug.debug("   Level: "+this.levelData.id);
			Debug.debug("================");
		}
	};

	p.buildLevel = function()
	{
		var levelData = this.levelData;
		this.currentTileIndex = 0;
		this.targetTileIndex = 1;
		this.walls = [];
		this.guards = this.guards || [];
		this.tiles = [];
		this.decorations = [];
		var levelContainer = this.panel.levelContainer,
			floorContainer = this.panel.floorContainer,
			wallTopContainer = this.panel.wallTopContainer;
		var config = this.config, data;
		var items = levelData.items;
		var i;
		//set up floor tiles
		var finalLevel = this.roundsPlayed + 1 >= 3;
		var elmoPath = levelData.elmoPath;
		for(i = 0; i < elmoPath.length; ++i)
		{
			data = elmoPath[i];
			var tile = new GoalTile(this, finalLevel && i + 1 == elmoPath.length);
			this.tiles.push(tile);
			floorContainer.addChild(tile);
			tile.visible = i <= 1;
			tile.position.x = data.x;
			tile.position.y = data.y;
		}
		//set up items in the level
		for(i = 0; i < items.length; ++i)
		{
			data = items[i];
			var item = new LevelItem(data, config.items[data.id]);
			switch(item.type)
			{
				case "wall":
					levelContainer.addChild(item);
					this.walls.push(item);
					break;
				case "wallTop":
					wallTopContainer.addChild(item);
					this.walls.push(item);
					break;
				case "shadow":
					floorContainer.addChild(item);
					this.decorations.push(item);
					break;
				case "art":
					levelContainer.addChild(item);
					this.decorations.push(item);
					break;
			}
		}
		//set up Elmo
		if(!this.elmo)
			this.elmo = new Elmo(this);
		else
			this.elmo.playIdle();
		this.elmo.position.x = this.tiles[0].position.x;
		this.elmo.position.y = this.tiles[0].position.y;
		levelContainer.addChild(this.elmo);
		//set up guards
		var guardPaths = levelData.guardPaths;
		for(i = 0; i < guardPaths.length; ++i)
		{
			var guard;
			if(this.guards[i])
				guard = this.guards[i];
			else
			{
				guard = new Guard(this);
				this.guards.push(guard);
			}
			var mask = levelData.guardLightMasks ? levelData.guardLightMasks[i] : null;
			guard.setPath(guardPaths[i], mask);
			levelContainer.addChild(guard);
		}
		
		//sort items in the level to ensure correct layering
		this.panel.levelContainer.children.sort(sorter);
		//do it twice to make sure it is stable (sometimes it was a little odd for art/walls)
		this.panel.levelContainer.children.sort(sorter);
	};
	
	p.cleanLevel = function()
	{
		this.panel.floorContainer.removeChildren();
		this.panel.levelContainer.removeChildren();
		this.panel.wallTopContainer.removeChildren();
		var i;
		for(i = 0; i < this.walls.length; ++i)
			this.walls[i].destroy();
		for(i = 0; i < this.tiles.length; ++i)
			this.tiles[i].destroy();
		for(i = 0; i < this.decorations.length; ++i)
			this.decorations[i].destroy();
		this.walls = this.tiles = this.decorations = null;
		for(i = 0; i < this.guards.length; ++i)
			this.guards[i].cleanup();
	};

	p.enterDone = function()
	{
		this.app.on("update", this.update, -2);
		this.startLevel();
	};
	
	p.startLevel = function()
	{
		//enable characters and UI
		for(var i = 0; i < this.guards.length; ++i)
		{
			this.guards[i].enabled = true;
			this.guards[i]._nextNode();//start them on the first node
		}
		this.elmo.enabled = true;
		this.elmo.playIdle();
		this.tiles[this.targetTileIndex].enabled = true;
		//reset variables
		this.wrongAnswers = 0;
		this.correctAnswers = 0;
		this.elmoClicks = 0;
		this.guardClicks = 0;
		this.timeouts = 0;
		this.hintsEnabled = false;
		this.timeoutTimer = this.timeoutTime;
		this.timeSinceTimeout = -1;
		
		this.appIsPlaying = true;
		
		var list;
		switch(this.roundsPlayed)
		{
			case 0:
				list = ["Elmo_AWickedChicken", "Elmo_WaitUntilChicken", "Elmo_Orange"];
				break;
			case 1:
				list = ["Elmo_Rd2_MoreChickens", "Elmo_Rd2_MoveElmo"];
				break;
			case 2:
				list = ["Elmo_Rd3_MoreChickens"];
				break;
		}
		this.voPlayer.play(list);
		
		this.app.trackEvent(["GameBEGIN",
			"mazeNumber_0" + (this.roundsPlayed + 1) + "_mazeDifficulty_" +
				DIFFICULTY[this.currentDifficulty]]);
	};
	
	p.update = function(elapsed)
	{
		if(this.timeoutTimer > 0 && !this.voPlayer.playing)
		{
			this.timeoutTimer -= elapsed;
			if(this.timeoutTimer <= 0)
			{
				this.timeoutTimer = this.timeoutTime;
				if(this.timeSinceTimeout < 0)
				{
					this.timeSinceTimeout = 0;
					this.app.trackEvent(["TimeoutPlay",
						"mazeNumber_0" + (this.roundsPlayed + 1) + "_mazeDifficulty_" +
							DIFFICULTY[this.currentDifficulty]]);
				}
				
				++this.timeouts;
				if(this.timeouts == 1)
				{
					this.voPlayer.play(["Elmo_TO1_MoveTo", "Elmo_Orange"]);
				}
				else if(this.timeouts == 2)
				{
					var list = ["Elmo_TO2_ToMoveElmo"];
					if(this.timeoutToggle)
					{
						list.push(this.app.hasTouch ?
									"Elmo_TO2_TapOnElmo" :
									"Elmo_TO2_ClickOnElmo");
					}
					else
					{
						list.push(this.app.hasTouch ? "Elmo_TO2_TapOn" : "Elmo_TO2_ClickOn");
						list.push("Elmo_Orange");
					}
					this.timeoutToggle = !this.timeoutToggle;
					this.voPlayer.play(list);
				}
				else//3+
				{
					this.voPlayer.play(["Elmo_TO3_RememberGetTo", "Elmo_Orange"]);
					this.timeouts = 0;
				}
			}
		}
		if(this.timeSinceTimeout >= 0)
		{
			this.timeSinceTimeout += elapsed;
		}
		
		//sort items in the level to ensure correct layering
		this.panel.levelContainer.children.sort(sorter);
	};
	
	function sorter(a, b)
	{
		//based on y position at ground, even for paintings
		return a.worldPos - b.worldPos;
	}
	
	p.enableHints = function()
	{
		this.timeoutTimer = 0;
		this.resetTimeouts();
		this.hintsEnabled = true;
	};
	
	p.resetTimeouts = function()
	{
		if(this.timeSinceTimeout > 0)
		{
			this.app.trackEvent(["TOReEnage",
				"mazeNumber_0" + (this.roundsPlayed + 1) + "_mazeDifficulty_" +
					DIFFICULTY[this.currentDifficulty],
				Math.round(this.timeSinceTimeout)]);
		}
		this.timeSinceTimeout = -1;
	};
	
	p.isHintActive = function(pathStep)
	{
		return this.hintsEnabled && pathStep == this.currentTileIndex;
	};
	
	//triggers the "go now" hint
	p.triggerMoveHint = function(pathStep)
	{
		if(this.isHintActive(pathStep))
		{
			//if pathStep is the current path step, then
			//play some VO and highlight tile
			var tile = this.tiles[pathStep + 1];
			tile.highlight();
			this.voPlayer.play(["Elmo_MoveNow", 1000, tile.unhighlight], null, tile.unhighlight);
		}
	};

	p.startElmoWalk = function()
	{
		//see if the instructions were playing.
		if(this.voPlayer.playing && this.voPlayer.voList.indexOf("Elmo_WaitUntilChicken") > -1)
		{
			this.app.trackEvent(["Skipped", "InstructionsMaze_play_" + this.app.totalPlays,
									Math.round(this.voPlayer.getElapsed())]);
			//only actually interrupt VO on subsequent plays
			if(this.app.totalPlays > 1)
				this.voPlayer.stop();
		}
		else
			this.voPlayer.stop();
		
		var tile = this.tiles[this.targetTileIndex];
		this.elmo.walkTo(tile.position.x, tile.position.y);

		this.elmo.enabled = false;
		this.tiles[this.targetTileIndex].enabled = false;
		
		this.timeoutTimer = 0;
		this.resetTimeouts();
	};

	p.catchElmo = function()
	{
		this.app.trackEvent(["GameSUCCESSInfo_mazeMove",
			"movefailure_" + this.targetTileIndex + "_mazeNumber_0" + (this.roundsPlayed + 1) +
				"_mazeDifficulty_" + DIFFICULTY[this.currentDifficulty]]);
		++this.wrongAnswers;
		
		this.resetElmo();
		
		this.voPlayer.stop();
	};
	
	p.catchElmoVO = function()
	{
		//don't play this if the player started moving while the chicken was bawking
		if(!this.elmo.enabled) return;
		
		if(this.wrongAnswers == 1)
		{
			this.voPlayer.play(["Elmo_WA1_UhOh", "Elmo_WA1_TryAgain"]);
		}
		else if(this.wrongAnswers == 2)
		{
			this.voPlayer.play("Elmo_WA2_RememberWait");
		}
		else//3+
		{
			this.voPlayer.play(["Elmo_WA3_NotAgain", "Elmo_WA3_ElmoWillTell"],
				this.enableHints.bind(this));
		}
	};
	
	p.pauseGuards = function()
	{
		for(var i = 0; i < this.guards.length; ++i)
		{
			this.guards[i].pause();
		}
	};
	
	p.resetElmo = function()
	{
		var tile = this.tiles[this.currentTileIndex];
		var pos = this.elmo.position;
		pos.x = tile.position.x;
		pos.y = tile.position.y;
		this.elmo.enabled = true;
		this.tiles[this.targetTileIndex].enabled = true;
		if(!this.hintsEnabled)
		{
			this.timeoutTimer = this.timeoutTime;
			this.resetTimeouts();
		}
		
		//resume guards
		for(var i = 0; i < this.guards.length; ++i)
		{
			this.guards[i].resume();
		}
	};

	p.nextTile = function()
	{
		this.app.trackEvent(["GameSUCCESSInfo_mazeMove",
			"movesuccess_" + this.targetTileIndex + "_mazeNumber_0" + (this.roundsPlayed + 1) +
				"_mazeDifficulty_" + DIFFICULTY[this.currentDifficulty]]);
		this.currentTileIndex++;
		this.targetTileIndex++;
		
		this.correctAnswers++;
		
		var vo;
		if(this.targetTileIndex >= this.tiles.length)
		{
			//stop guards
			for(var i = 0; i < this.guards.length; ++i)
			{
				this.guards[i].stop();
			}
			
			this.elmo.playWin();
			Sound.instance.play("SFX_FinalTileWin");
			//next level/state
			if(this.roundsPlayed == 2)
				vo = ["Elmo_FinalCA_WeDidIt", "Elmo_FinalCA_NiceWork"];
			else
				vo = this.config.correctVO.random();
			this.voPlayer.play(vo, this.nextLevel.bind(this));
			//tracking
			this.app.trackEvent(["GameSUCCESS",
				"mazeNumber_0" + (this.roundsPlayed + 1) + "_mazeDifficulty_" +
					DIFFICULTY[this.currentDifficulty] + "_WA_" + this.wrongAnswers + "_CA_" +
					this.correctAnswers,
				this.wrongAnswers]);
			this.app.trackEvent(["GameSUCCESSInfo_characterclicks",
				"mazeNumber_0" + (this.roundsPlayed + 1) + "_mazeDifficulty_" +
					DIFFICULTY[this.currentDifficulty] + "_elmoclicks_" + this.elmoClicks +
					"_chickenclicks_" + this.guardClicks,
				this.guardClicks + this.elmoClicks]);
			
			this.appIsPlaying = false;
			
			return;
		}
		
		Sound.instance.play("SFX_WinTile");
		
		//only play vo on the first tile
		if(this.currentTileIndex == 1)
		{
			if(this.correctToggle)
				vo = "Elmo_LetsKeepGoing";
			else
				vo = "Elmo_NextSquare";
			this.correctToggle = !this.correctToggle;
			this.voPlayer.play(vo);
		}
		//enable next tile
		this.startNextTile();
	};
	
	p.startNextTile = function()
	{
		this.elmo.enabled = true;
		var tile = this.tiles[this.targetTileIndex-1];
		tile.enabled = false;
		if(this.targetTileIndex >= 2)
		{
			this.tiles[this.targetTileIndex - 2].visible = false;
		}
		tile = this.tiles[this.targetTileIndex];
		tile.visible = true;
		tile.enabled = true;
		this.timeoutTimer = this.timeoutTime;
		this.timeSinceTimeout = -1;
		
		Sound.instance.play("SFX_NewTile");
	};
	
	p.nextLevel = function()
	{
		for(var i = 0; i < this.guards.length; ++i)
		{
			this.guards[i].stop();
		}
		
		if(this.wrongAnswers >= 2)
			this.currentDifficulty--;
		else if(this.wrongAnswers === 0)
			this.currentDifficulty++;
		var maxDifficulty = this.config.levels.length - 1;
		if(this.currentDifficulty < 0)
			this.currentDifficulty = 0;
		else if(this.currentDifficulty > maxDifficulty)
			this.currentDifficulty = maxDifficulty;
		
		if(++this.roundsPlayed >= 3)
		{
			this.app.selectLetter();
			this.app.cutsceneData =
			{
				nextState: "clue",
				cutscene: "scene1",
				skipLabel: "CutScreen1"
			};
			this.manager.state = "cutscene";
		}
		else
		{
			this.panel.showTransition(this.loadNextLevel.bind(this));
		}
	};
	
	p.loadNextLevel = function()
	{
		//start loading the next level, or go to the next stage
		this.cleanLevel();
		this.chooseLevel();
		this.buildLevel();
		this.panel.hideTransition(this.startLevel.bind(this));
	};
	
	p.exitStart = function()
	{
		this.app.off("update", this.update);
		this.voPlayer.stop();
	};

	p.exit = function()
	{
		s.exit.call(this);
		
		if(this.appIsPlaying)
		{
			this.app.trackEvent(["GameINCOMPLETE",
				"mazeNumber_0" + (this.roundsPlayed + 1) + "_mazeDifficulty_" +
					DIFFICULTY[this.currentDifficulty] + "_WA_" + this.wrongAnswers + "_CA_" +
					this.correctAnswers,
				this.wrongAnswers]);
			this.app.trackEvent(["Quit",
				"mazeNumber_0" + (this.roundsPlayed + 1) + "_mazeDifficulty_" +
					DIFFICULTY[this.currentDifficulty]]);
		}
		
		if(!this.elmo) return;
		
		this.panel.teardown();
		var i;
		for(i = 0; i < this.guards.length; ++i)
			this.guards[i].destroy();
		for(i = 0; i < this.walls.length; ++i)
			this.walls[i].destroy();
		for(i = 0; i < this.tiles.length; ++i)
			this.tiles[i].destroy();
		for(i = 0; i < this.decorations.length; ++i)
			this.decorations[i].destroy();
		this.elmo.destroy();
		this.guards = this.elmo = this.walls = this.tiles = null;
		this._levelAssets.length = 0;
	};

	p.destroy = function()
	{
		s.destroy.call(this);
		
		this.update = this.enableHints = this.nextLevel = null;
	};

	namespace('heist').StealthState = StealthState;
}());